import React from 'react'
import { getIn, useFormikContext } from 'formik'
import { padStart } from 'lodash'
import moment from 'moment'

import { Table, Row, SubmitWrapper } from './styles'
import { NumberInput, ColorLabel, Tooltip, Button } from 'components/atoms'

import { loadNs } from 'aa_common/front-end/i18n-config'

const t = loadNs(['common', 'components/organisms/settings/asset-code-start-number-page'])
const YEAR_MONTH_FORMAT = 'YYYYMM'

type Props = {
  lengthRuleNumber: number
}

const Form: React.FC<Props> = ({ lengthRuleNumber = 3 }) => {
  const { values } = useFormikContext()
  const currentYearMonth = moment().format(YEAR_MONTH_FORMAT)
  const wholeOffice = getIn(values, 'whole_office')

  const startCode = padStart(getIn(values, 'whole_office').toString(), lengthRuleNumber, '0')
  const codeSample = `A001-${currentYearMonth}${startCode}`

  return (
    <>
      {wholeOffice !== null && (
        <Table>
          <Row className="last">
            <div className="label">{getIn(values, 'whole_office_text')}</div>
            <div className="content">
              {getIn(values, 'is_editable') ? (
                <NumberInput name="initial_value" style={{ width: 100 }} maxLength={lengthRuleNumber} />
              ) : (
                <Tooltip content={t('disabled_tooltip_msg')} placement="top">
                  <NumberInput name="whole_office" style={{ width: 100 }} disabled />
                </Tooltip>
              )}
              <ColorLabel color="disabled" style={{ marginLeft: 10, marginTop: 5 }}>
                {t('code_sample', { code: codeSample })}
              </ColorLabel>
            </div>
          </Row>
        </Table>
      )}
      <SubmitWrapper>
        <Button type="submit" color="blue" size="custom" style={{ width: 70 }}>
          {t('actions.save')}
        </Button>
      </SubmitWrapper>
    </>
  )
}

export default Form
